import { Component, OnDestroy, OnInit } from '@angular/core';
import { ZoneService } from '../../services/zone.service';
import { Zone } from '../../models/zone';
import { Sensor, SensorTypes } from '../../models/sensor';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../services/data.service'
import { SocketIoService } from 'src/app/services/socket-io.service';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common'


@Component({
    selector: 'app-client-admin',
    templateUrl: './client-admin.component.html',
    styleUrls: ['./client-admin.component.less']
})
export class ClientAdminComponent implements OnInit, OnDestroy {

    private subscription: Subscription;
    currentCompany: any = null
    navLinks: any[];
    activeLinkIndex = -1;

    constructor(private zoneService: ZoneService,
        private router: Router,
        private location: Location,
        private route: ActivatedRoute,
        private dataService: DataService,
        private socketService: SocketIoService) {

        if (localStorage.getItem('currentCompany')) {
          let company = JSON.parse(localStorage.getItem('currentCompany'));
          this.currentCompany = company.name
        }
        this.subscription = this.dataService.sharedCompanyId$.subscribe(company => {
          // this.currentCompanyId = company;
          if (!this.currentCompany && localStorage.getItem('currentCompany')) {
            let company = JSON.parse(localStorage.getItem('currentCompany'));
  
            this.currentCompany = company ? company.name : null
            // this.currentCompanyId = company ? company._id : null
            this.dataService.updateCompany(company.name)
            this.dataService.updateCompanyId(company._id)
          }
        })
        // this.subscription = this.dataService.sharedCompany$.subscribe(company => {
        //     this.currentCompany = company;
        // })

        this.navLinks = [
            {
              label: 'Profile',
              link: './profile',
              index: 0,
            },
            {
              label: 'Users',
              link: './users',
              index: 1
            },
            {
              label: 'Settings',
              link: './setting',
              index: 2
            },
          ];
    }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    updateActiveLinkIndex(index){
        this.activeLinkIndex = index
    }

}
